module.exports = __webpack_public_path__ + "img/H-63-ER-1000-MI.c3399ffc.png";